import React, { useEffect, useState } from "react";
import "./index.scss";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import * as _ from "lodash";

const ChatHeader = () => {
  const { t } = useTranslation();
  const [isGood, setIsGood] = useState(true);
  const staffManage = useSelector((state) => state.staffManage);
  const sessionManage = useSelector((state) => state.sessionManage);

  const staff = _.get(staffManage, "staff", {});
  const staffReport = _.get(sessionManage, "reportStaff");

  useEffect(() => {
    const good = _.get(staffReport, "good", 0);
    const bad = _.get(staffReport, "bad", 0);
    const total = good + bad;
    const averageGood = total ? _.round((good / total) * 100, 1) : 0;

    if (total) {
      setIsGood(averageGood >= 50);
    }
  }, [staffReport]);

  return (
    <div className="chat-header">
      <div className="row g-0">
        <div className="col-md-3 border-end border-bottom">
          <div className="h-60 px-3 d-flex gap-2 justify-content-between align-items-center">
            <div className=" d-flex gap-2 align-items-center">
              <img
                className="rounded-circle"
                width="42px"
                height="42px"
                src="/img/chat/avatar.png"
                alt=""
              />
              <div>
                <div className="fw-semibold">{_.get(staff, "name", "")}</div>
                <div className="small">
                  <span className="color-info">●</span> {t("agent.nav.online")}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-9 border-bottom">
          <div className="h-60 px-3 d-flex gap-2 flex-wrap justify-content-between align-items-center small">
            <div className="d-flex gap-2 flex-wrap align-items-center">
              {isGood && (
                <span className="btn btn-sm btn-success-light">
                  {t("agent.chat.excellent")}
                </span>
              )}
              {!isGood && (
                <span className="btn btn-sm btn-danger-light">
                  {t("agent.chat.bad")}
                </span>
              )}
              <span>
                <span className="color-gray">
                  {t("agent.chat.enquired_visitors")}
                </span>{" "}
                {_.get(staffReport, "total", 0)}
              </span>
              <span className="color-gray">•</span>
              <span>
                <span className="color-gray">{t("agent.chat.tickets")}</span>{" "}
                {_.get(staffReport, "ticket", 0)}
              </span>
              <span className="color-gray">•</span>
              <span>
                <span className="color-gray">{t("agent.chat.served")}</span>{" "}
                {_.get(staffReport, "served", 0)}
              </span>
            </div>
            <button
              style={{ border: "none", background: "none" }}
              className="color-gray"
              onClick={() => {
                window.open(
                  "https://wiki.izihelp.com/vi/knowledgebase/chat-voi-khach-hang-tu-live-chat/",
                  "_blank"
                );
              }}
            >
              <img src="/img/chat/icon/help.svg" alt="" />{" "}
              {t("agent.nav.help_center")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
